import { W as WuiIcon$1, d as defineCustomElement$1 } from './p-Da2lAZSv.js';

const WuiIcon = WuiIcon$1;
const defineCustomElement = defineCustomElement$1;

export { WuiIcon, defineCustomElement };
